export default "__VITE_ASSET__P2WRL2se__"